import { httpCodes } from '@shared/constants/httpCodes'

import BaseHTTPError from './BaseHTTPError'

export default class BadRequestError<Data> extends BaseHTTPError<Data> {
  constructor(info: { message: string; action: string; data?: Data }) {
    super({
      name: BadRequestError.name,
      httpCode: httpCodes.BAD_REQUEST,
      message: info.message,
      action: info.action,
      data: info?.data
    })
  }
}
